import {ChartData} from "./chart-data";
import {GUID} from "app/shared/models/GUID-interface";
import {CodeNameSummaryChart} from '../../stocks/models/code-name';

export class ChartDataGUID implements GUID{
    constructor(
        public readonly GUID: string,
        public readonly data: ChartData,
        public readonly summaryData: {codes: CodeNameSummaryChart[], wrhCnt: number, skuCnt: number}){
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-data-GUID.ts